import React from 'react';

import { FormControl, ButtonGroup, ButtonGroupItem } from 'components/Shared/Forms';
import { STYLED_MARKER } from 'components/MarkerSettings/IconOptions';

const handleClick = (e, onChange, i) => {
    e.preventDefault();
    onChange(i);
};

// TODO: Replace with the the actual marker picker we want to use
const MarkerPicker = (props) => {
    const { input, color } = props;
    return (
        <FormControl width="100%" {...props}>
            <ButtonGroup>
                {STYLED_MARKER.map((marker, i) => (
                    <ButtonGroupItem
                        glyph={marker}
                        key={i}
                        color={color}
                        selected={input.value === i}
                        onClick={(e) => handleClick(e, input.onChange, i)}
                    />
                ))}
            </ButtonGroup>
        </FormControl>
    );
};

export default MarkerPicker;
